import React from 'react'

export default function LocationPinIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="16" fill="#119955" fillOpacity="0.16" stroke="#FAFAFA" strokeWidth="2"/>
      <circle cx="17" cy="17" r="8" fill="#FAFAFA"/>
    </svg>
  )
}
